export default __webpack_public_path__ + "media/images/play-d8d4a7be11053d7430d3e2de35af8083.svg";